<template>
  <nav class="sky__breadcrumb flex text-xs items-center" :class="{dark}">
    <script v-if="!noEnriched" type="application/ld+json" v-html="jsonld" />
    <nuxt-link :to="value[value.length - 2] ? value[value.length - 2].to : '/'">
      <icon-arrow style="width: 12px;" left class="mr-2" :color="dark ? 'white' : undefined" />
    </nuxt-link>
    <ul class="sky__breadcrumb-list flex truncate">
      <li class="truncate">
        <nuxt-link to="/" class="sky__breadcrumb-list-item truncate">
          Accueil
        </nuxt-link>
      </li>
      <li v-for="(v, index) in value" :key="index" class="sky__breadcrumb-list-item truncate">
        <template v-if="index !== value.length - 1">
          <nuxt-link :to="v.to" class="truncate">
            {{ v.text }}
          </nuxt-link>
        </template>
        <template v-else>
          {{ v.text }}
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
import IconArrow from './icons/IconArrow'

export default {
  components: {
    IconArrow
  },
  props: {
    value: {
      required: false,
      default: () => [],
      type: Array
    },
    dark: {
      required: false,
      default: false,
      type: Boolean
    },
    noEnriched: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  computed: {
    jsonld () {
      return {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Accueil',
            item: 'https://www.skylantern.fr'
          },
          ...this.value.map((v, index) => {
            return {
              '@type': 'ListItem',
              position: index + 2,
              name: v.text,
              item: 'https://www.skylantern.fr' + encodeURI(v.to)
            }
          })
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__breadcrumb.dark {
    @apply text-white;
  }

  .sky__breadcrumb-list-item {
    display: flex;
    &:before {
      content: '|';
      @apply px-1;
      display: block;
    }
    &:first-child {
      &:before {
        display: none;
      }
    }
  }
</style>
